<template lang="html">
<div class="alerts-container">
    <transition-group name="scale-transition">
        <v-alert
        @input="dismissed(alert.id)"
        v-for="alert in alerts"
        :color="alert.color"
        :icon="alert.icon"
        dismissible
        :key="alert.id"
        :value="true"
        >
            {{ alert.text }}
        </v-alert>
    </transition-group>
</div>
</template>

<script>
import * as actions from '@/constants/actions';

export default {
    name: 'alerts',
    data() {
        return {
        };
    },
    computed: {
        alerts() {
            return this.$store.state.alerts;
        },
    },
    methods: {
        /**
         * remove dismissed alerts from the array in vuex
         * @param  {String} alertId alert id
         */
        dismissed(alertId) {
            this.$store.dispatch(actions.REMOVE_ALERT, alertId);
        },
    },
};
</script>

<style lang="scss">
.alerts-container {
    position: absolute;
    width: 100%;
    z-index: 5; // above the map, nav drawer, etc.

    .scale-transition-leave-active {
        height: 0px;
        margin: 0px;
        padding: 0px;
        border: 0px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Alerts.vue